import { SimulatorType } from "@/types/api/SimulatorType"

const LIVEKIT_SIMULATOR_TYPE: string = SimulatorType.LIVEKIT
const TRANSIENT_LIVEKIT_FIELD = "livekit_dispatch_mode"

/**
 * Strips the LiveKit Dispatch Mode selector's transient UI-only field
 * (`livekit_dispatch_mode`) from metadata right before it reaches the
 * backend.
 *
 * That field exists purely so the selector's raw "Automatic" / "Explicit"
 * selection is visible to validateAgentCreate — specifically so "Explicit
 * dispatch selected, Agent Name left blank" can be caught as a real,
 * save-blocking error (see validateAgentCreate.ts). Dispatch mode itself is
 * still meant to be fully derivable from livekit_agent_name for anything
 * that matters to the backend (see useDispatchMode), so this key must never
 * actually persist — mirrors getWebSocketMetadataForSave's role as the
 * choke point that sanitizes metadata right before a save.
 */
export function getLiveKitMetadataForSave(
  simulatorType: string,
  metadata: Record<string, unknown>,
): Record<string, unknown> {
  if (
    simulatorType !== LIVEKIT_SIMULATOR_TYPE ||
    !(TRANSIENT_LIVEKIT_FIELD in metadata)
  ) {
    return metadata
  }

  const nextMetadata = { ...metadata }
  delete nextMetadata[TRANSIENT_LIVEKIT_FIELD]
  return nextMetadata
}
